<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class=" inner-card">
                    <h4 class="card-title ">Ground</h4>
                    <div class="card-body text-justify">
                        <p class="lead text-justify inner-lead"><i>Area(5700 m2)</i></p>
                       <div class="row text-center">
                           <div class="col-12">
                            <a  href="/assets/img/campus/ground/1.jpeg" data-lightbox="Ground"> <img src="/assets/img/campus/ground/1.jpeg" alt="Ground" class="img-fluid rounded"></a>
                            </div>
                       </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>